/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createAccountDetail = /* GraphQL */ `
  mutation CreateAccountDetail(
    $input: CreateAccountDetailInput!
    $condition: ModelAccountDetailConditionInput
  ) {
    createAccountDetail(input: $input, condition: $condition) {
      user_id
      bank_code
      bank_name
      branch_code
      branch_name
      account_category
      account_num
      account_person_name
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateAccountDetail = /* GraphQL */ `
  mutation UpdateAccountDetail(
    $input: UpdateAccountDetailInput!
    $condition: ModelAccountDetailConditionInput
  ) {
    updateAccountDetail(input: $input, condition: $condition) {
      user_id
      bank_code
      bank_name
      branch_code
      branch_name
      account_category
      account_num
      account_person_name
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteAccountDetail = /* GraphQL */ `
  mutation DeleteAccountDetail(
    $input: DeleteAccountDetailInput!
    $condition: ModelAccountDetailConditionInput
  ) {
    deleteAccountDetail(input: $input, condition: $condition) {
      user_id
      bank_code
      bank_name
      branch_code
      branch_name
      account_category
      account_num
      account_person_name
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createInvitee = /* GraphQL */ `
  mutation CreateInvitee(
    $input: CreateInviteeInput!
    $condition: ModelInviteeConditionInput
  ) {
    createInvitee(input: $input, condition: $condition) {
      user_id
      invitee_id
      invitee_conversion_date
      reward_id
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateInvitee = /* GraphQL */ `
  mutation UpdateInvitee(
    $input: UpdateInviteeInput!
    $condition: ModelInviteeConditionInput
  ) {
    updateInvitee(input: $input, condition: $condition) {
      user_id
      invitee_id
      invitee_conversion_date
      reward_id
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteInvitee = /* GraphQL */ `
  mutation DeleteInvitee(
    $input: DeleteInviteeInput!
    $condition: ModelInviteeConditionInput
  ) {
    deleteInvitee(input: $input, condition: $condition) {
      user_id
      invitee_id
      invitee_conversion_date
      reward_id
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createTransfer = /* GraphQL */ `
  mutation CreateTransfer(
    $input: CreateTransferInput!
    $condition: ModelTransferConditionInput
  ) {
    createTransfer(input: $input, condition: $condition) {
      status
      memo
      has_failed
      transferred_at
      subtotal
      fee
      tax
      total
      planned_month
      planned_name
      planned_period
      id
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateTransfer = /* GraphQL */ `
  mutation UpdateTransfer(
    $input: UpdateTransferInput!
    $condition: ModelTransferConditionInput
  ) {
    updateTransfer(input: $input, condition: $condition) {
      status
      memo
      has_failed
      transferred_at
      subtotal
      fee
      tax
      total
      planned_month
      planned_name
      planned_period
      id
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteTransfer = /* GraphQL */ `
  mutation DeleteTransfer(
    $input: DeleteTransferInput!
    $condition: ModelTransferConditionInput
  ) {
    deleteTransfer(input: $input, condition: $condition) {
      status
      memo
      has_failed
      transferred_at
      subtotal
      fee
      tax
      total
      planned_month
      planned_name
      planned_period
      id
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createRewardCategory = /* GraphQL */ `
  mutation CreateRewardCategory(
    $input: CreateRewardCategoryInput!
    $condition: ModelRewardCategoryConditionInput
  ) {
    createRewardCategory(input: $input, condition: $condition) {
      name
      type
      amount
      is_active
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRewardCategory = /* GraphQL */ `
  mutation UpdateRewardCategory(
    $input: UpdateRewardCategoryInput!
    $condition: ModelRewardCategoryConditionInput
  ) {
    updateRewardCategory(input: $input, condition: $condition) {
      name
      type
      amount
      is_active
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRewardCategory = /* GraphQL */ `
  mutation DeleteRewardCategory(
    $input: DeleteRewardCategoryInput!
    $condition: ModelRewardCategoryConditionInput
  ) {
    deleteRewardCategory(input: $input, condition: $condition) {
      name
      type
      amount
      is_active
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createReward = /* GraphQL */ `
  mutation CreateReward(
    $input: CreateRewardInput!
    $condition: ModelRewardConditionInput
  ) {
    createReward(input: $input, condition: $condition) {
      user_id
      amount
      reward_category_id
      transfer_id
      owner
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateReward = /* GraphQL */ `
  mutation UpdateReward(
    $input: UpdateRewardInput!
    $condition: ModelRewardConditionInput
  ) {
    updateReward(input: $input, condition: $condition) {
      user_id
      amount
      reward_category_id
      transfer_id
      owner
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteReward = /* GraphQL */ `
  mutation DeleteReward(
    $input: DeleteRewardInput!
    $condition: ModelRewardConditionInput
  ) {
    deleteReward(input: $input, condition: $condition) {
      user_id
      amount
      reward_category_id
      transfer_id
      owner
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateContact = /* GraphQL */ `
  mutation UpdateContact(
    $input: UpdateContactInput!
    $condition: ModelContactConditionInput
  ) {
    updateContact(input: $input, condition: $condition) {
      id
      name
      phone_number
      email
      contents
      is_active
      memo
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteContact = /* GraphQL */ `
  mutation DeleteContact(
    $input: DeleteContactInput!
    $condition: ModelContactConditionInput
  ) {
    deleteContact(input: $input, condition: $condition) {
      id
      name
      phone_number
      email
      contents
      is_active
      memo
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createContact = /* GraphQL */ `
  mutation CreateContact(
    $input: CreateContactInput!
    $condition: ModelContactConditionInput
  ) {
    createContact(input: $input, condition: $condition) {
      id
      name
      phone_number
      email
      contents
      is_active
      memo
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
